<template>
  <div id="login">
    <div>
      <div id="logo"><a href="https://www.bigvisiontech.com/" target="_blank"><img src="../assets/images/logo.png" alt=""></a></div>
      <div id="login_box">
        <div class="login clearFix">
          <div v-show="qrcode" class="login_wechat_div pc_qr">
            <p class="login_wechat_tips fl_l animated headShake" @click="qrcode=false">账号登录</p>
            <img src="../assets/images/pc.png" alt="" class="fl_l" @click="qrcode=false">
          </div>
          <div v-show="qrcode" id="login_left" class="login_left fl_l">

          </div>

          <div v-show="!qrcode" class="login_left fl_l">
            <div class="login_wechat_div clearFix">
              <p class="login_wechat_tips fl_l animated headShake" @click="qrcode=true">扫码登录更便捷</p>
              <img src="../assets/images/qrcode.png" alt="" class="fl_l" @click="qrcode=true">
            </div>
            <div class="login_l_title">
              <span :class="loginWay === 'pwd'?'active':''" @click="login_way('pwd')">密码登录</span>
              <span :class="loginWay === 'yzm'?'active':''" @click="login_way('yzm')">验证码登录</span>
            </div>
            <!-- 密码登录 -->
            <form :action="loginAction" method="post" id="login_form_pwd" v-if="loginWay === 'pwd'">
              <div class="login_l_tel mt30 clearFix">
                <div class="login_l_t_r w1 fl_r" :class="login_pwd_tel_errShow?'bor_red':''">
                  <el-input autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" name="username" maxlength="20" v-model="login_pwd_tel" placeholder="请输入用户名" @focus="login_pwd_tel_focus()" @blur="login_pwd_tel_blur()"></el-input>
                  <p class="login_tel_tips" v-if="login_pwd_tel_tips">验证完成后，可以使用该账号登录或找回密码</p>
                  <p class="login_err_tips col_red" v-if="login_pwd_tel_errShow">{{login_pwd_tel_errMsg}}</p>
                </div>
              </div>
              <div class="login_l_pwd mt30" :class="login_pwd_errShow?'bor_red':''">
                <el-input autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" name="password" v-model="login_pwd" placeholder="输入登录密码" show-password @focus="login_pwd_focus()" @blur="login_pwd_blur()"></el-input>
                <p class="login_err_tips col_red" v-if="login_pwd_errShow">{{login_pwd_errMsg}}</p>
              </div>
              <input type="text" name="authtype" value="PASSWORD" hidden>
              <div class="login_l_bottom">
                <el-button type="primary" :disabled="loginBtn_Pwd" @click="submit_pwd()">登 录</el-button>
                <button id="submit_pwd" hidden>提交</button>
              </div>
            </form>
            <!-- 手机验证码登录 -->
            <form :action="loginAction" method="post" id="login_from_yzm" v-else>
              <div class="login_l_tel mt30 clearFix">
                <div class="login_l_t_r w1 fl_r" :class="login_yzm_tel_errShow?'bor_red':''">
                  <el-input type="number" autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" name="mobile" maxlength="11" v-model="login_yzm_tel" placeholder="请输入手机号" @focus="login_yzm_tel_focus()" @blur="login_yzm_tel_blur()"></el-input>
                  <p class="login_tel_tips" v-if="login_yzm_tel_tips">验证完成后，可以使用该手机号登录或找回密码</p>
                  <p class="login_err_tips col_red" v-if="login_yzm_tel_errShow">{{login_yzm_tel_errMsg}}</p>
                </div>
              </div>
              <div class="login_l_pwd mt30" :class="login_yzm_errShow?'bor_red':''">
                <el-input name="code" autocomplete="new-password" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false" maxlength="6" v-model="login_yzm" placeholder="输入短信验证码" @focus="login_yzm_focus()" @blur="login_yzm_blur()"></el-input>
                <span class="login_l_getCode coutdown" :class="login_yzm_tel.length===11?'lightText':''" v-if="getCodeBtn" @click="getCode()">获取验证码</span>
                <span class="login_l_getCode coutdown" :class="login_yzm_tel.length===11?'lightText':''" v-else>倒计时<span>{{time}}</span>s</span>
                <p class="login_err_tips col_red" v-if="login_yzm_errShow">{{login_yzm_errMsg}}</p>
              </div>
              <input type="text" name="authtype" value="SMS" hidden>
              <div class="login_l_bottom">
                <el-button type="primary" :disabled="loginBtn_yzm" @click="submit_yzm()">登 录</el-button>
                <button id="submit_yzm" hidden>提交</button>
              </div>
            </form>

            <!-- <div class="login_l_b_other clearFix">
              <div class="login_l_b_o_right fl_r">
                <router-link to="/forgetPwd">忘记密码</router-link>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <a href="https://www.bigvisiontech.com/" target="_blank" id="footer">苏州比格威医疗科技有限公司荣誉出品</a>
    </div>

  </div>
</template>
<script>
import { getCode, getWxLoginUrlParams, logout } from '../api/api'
import '@/js/wxLogin'
import { _debounce } from "@/js/debounce";
import { getUrlSearch, isEmpty, isMobileNum, notLessThanLength } from '@/js/common';
export default {
  name: 'Login',
  data() {
    return {
      loginAction: process.env.VUE_APP_ACCOUNT_URL + '/login',
      // loginAction: 'http://192.168.128.6:8087/login',
      loginWay: 'pwd',
      value: '',
      checked: false,
      login_pwd_tel: '',
      login_pwd: '',
      login_pwd_tel_tips: false,
      login_pwd_tel_errShow: false,
      login_pwd_tel_errMsg: '',
      login_pwd_errShow: false,
      login_pwd_errMsg: '用户名或密码错误！',
      login_yzm_tel: '',
      login_yzm: '',
      login_yzm_tel_tips: false,
      login_yzm_tel_errShow: false,
      login_yzm_tel_errMsg: '',
      login_yzm_errShow: false,
      login_yzm_errMsg: '验证码错误！',
      loginBtn_Pwd: false,
      loginBtn_yzm: false,
      qrcode: true,
      fromProd: true,
      FP: false,
      projectList_show: false,
      projectList: [
        {
          id: 1,
          name: '亮柠檬门店系统',
          url: 'https://blemon-dev.bigvisiontech.com/'
        },
        {
          id: 2,
          name: '比格威管理系统',
          url: 'https://crm-dev.bigvisiontech.com/'
        }
      ],
      getCodeBtn: true,
      time: 60
    }
  },
  created() {
    let width = document.body.clientWidth
    if (getUrlSearch('err_msg')) {
      this.$message.error(getUrlSearch('err_msg'))
    }
    if (this.$route.query.qrcode || width < 500) {
      this.qrcode = false
    }
  },
  async mounted() {
    // this.fromProd = this.$route.query.fromProd
    let err_msg = this.$route.query.err_msg
    let error_type = this.$route.query.error_type
    if (error_type == 'EXISTS_OTHER_PROFGRAM') {
      this.$alert('请使用其他登录方式登录，进入安全中心，解绑微信号再重新绑定当前微信号！', '扫码登录失败', {
        confirmButtonText: '确定',
        callback: action => {
          logout()
        }
      });
    }
    // if (err_msg) this.fromProd = 'true'
    // if (this.fromProd !== 'true')  this.$router.push("/")
    let re = await getWxLoginUrlParams()
    console.log(re)
    this.$nextTick(() => {
      var obj = new WxLogin({
        self_redirect: false,
        id: "login_left",
        appid: re.appid,
        scope: re.scope,
        redirect_uri: re.redirect_uri,
        state: re.state,
        style: "",
        href: ""
      });

      let iframe = document.getElementsByTagName('iframe')[0]
      iframe.sandbox = "allow-forms allow-same-origin allow-scripts allow-top-navigation"
    })
  },
  methods: {
    login_way(way) {
      if (this.loginWay !== way) {
        this.loginWay = way
        this.clearAll()
      }
    },
    /********** 密码登录 **********/
    // 账号名输入框focus
    login_pwd_tel_focus() {
      this.login_pwd_tel_tips = true
      this.login_pwd_tel_errShow = false
    },
    // 账号名输入框blur
    login_pwd_tel_blur() {
      this.login_pwd_tel_tips = false
      this.login_pwd_telCheck(this.login_pwd_tel)
    },
    // 校验--账号名输入框
    login_pwd_telCheck(name) {
      if (isEmpty(name)) {
        this.login_pwd_tel_errShow = true
        this.login_pwd_tel_errMsg = '用户名不为空'
        return false
      } else {
        if (notLessThanLength(name, 3)) {
          this.login_pwd_tel_errShow = true
          this.login_pwd_tel_errMsg = '用户名不小于3位！'
          return false
        } else {
          this.login_pwd_tel_errShow = false
          this.login_pwd_tel_errMsg = ''
          return true
        }
      }
    },
    // 账号密码输入框focus
    login_pwd_focus() {
      this.login_pwd_errShow = false
      this.login_pwd_errMsg = ''
    },
    // 账号密码输入框blur
    login_pwd_blur() {
      this.login_pwdCheck(this.login_pwd)
    },
    // 校验--账号密码
    login_pwdCheck(val) {
      if (isEmpty(val)) {
        this.login_pwd_errShow = true
        this.login_pwd_errMsg = '密码不为空'
        return false
      } else {
        this.login_pwd_errShow = false
        this.login_pwd_errMsg = ''
        return true
      }
    },
    // 提交--密码登录
    submit_pwd: _debounce(function () {
      if (this.login_pwd_telCheck(this.login_pwd_tel) && this.login_pwdCheck(this.login_pwd)) {
        var doc = document.getElementById("submit_pwd");
        doc.click()
      }
    }),
    /********** 验证码登录 **********/
    // 手机号输入框focus
    login_yzm_tel_focus() {
      this.login_yzm_tel_tips = true
      this.login_yzm_tel_errShow = false
    },
    // 手机号输入框blur
    login_yzm_tel_blur() {
      this.login_yzm_tel_tips = false
      this.login_yzm_telCheck(this.login_yzm_tel)
    },
    // 校验--手机号输入框
    login_yzm_telCheck(tel) {
      if (isEmpty(tel)) {
        this.login_yzm_tel_errShow = true
        this.login_yzm_tel_errMsg = '手机号不为空'
        return false
      } else {
        if (isMobileNum(tel)) {
          return true
        } else {
          // this.login_yzm_tel = ''
          this.login_yzm_tel_errShow = true
          this.login_yzm_tel_errMsg = '手机号格式不正确'
          return false
        }
      }
    },
    // 获取验证码
    getCode() {
      if (this.login_yzm_telCheck(this.login_yzm_tel)) {
        this.coutDown()
        this.getCodeBtn = false
        console.log('tel: ', this.login_yzm_tel)
        getCode(this.login_yzm_tel).then(res => {
          console.log(res)
        })
      } else {
        this.$message.error('请正确填写手机号')
      }
    },
    // 获取验证码--倒计时
    coutDown() {
      var that = this
      var timeClock = setInterval(function () {
        that.time--;

        if (that.time == 0) {
          that.getCodeBtn = true
          clearInterval(timeClock);
          that.time = 60
        }
      }, 1000)
    },
    // 验证码输入框focus
    login_yzm_focus() {
      this.login_yzm_errShow = false
      this.login_yzm_errMsg = ''
    },
    // 验证码输入框blur
    login_yzm_blur() {
      this.login_yzmCheck(this.login_yzm)
    },
    // 校验--验证码输入框
    login_yzmCheck(code) {
      if (isEmpty(code)) {
        this.login_yzm_errShow = true
        this.login_yzm_errMsg = '验证码不为空'
        return false
      } else {
        this.login_yzm_errShow = false
        this.login_yzm_errMsg = ''
        return true
      }
    },
    // 提交--验证码登录
    submit_yzm: _debounce(function () {
      if (this.login_yzm_telCheck(this.login_yzm_tel) && this.login_yzmCheck(this.login_yzm)) {
        var doc = document.getElementById("submit_yzm");
        doc.click()
      }
    }),
    // 清除所有内容
    clearAll() {
      this.login_pwd_tel = '';
      this.login_pwd = '';
      this.login_pwd_tel_tips = ''
      this.login_pwd_tel_errShow = false
      this.login_pwd_tel_errMsg = ''
      this.login_pwd_errShow = false,
        this.login_pwd_errMsg = '',
        this.login_yzm_tel = ''
      this.login_yzm = ''
      this.login_yzm_tel_tips = false,
        this.login_yzm_tel_errShow = false,
        this.login_yzm_tel_errMsg = '',
        this.login_yzm_errShow = false,
        this.login_yzm_errMsg = ''
    }
  }
}
</script>
 
<style scoped>
@import url('../assets/css/base.css');
@import url('../assets/css/login.css');
</style>